/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSin } from '../../factoriesAny.js';
export var sinDependencies = {
  typedDependencies,
  createSin
};